import { CANCEL_REMOVE_GIFT_CARD } from 'redux/modules/order/actions/types';

const cancelGiftCardToRemove = () => ({
  type: CANCEL_REMOVE_GIFT_CARD,
});

export default cancelGiftCardToRemove;
